<div>Activity type: <strong>{{ type }}</strong></div>
